import { render } from "./NavMenu.vue?vue&type=template&id=751fdaf8"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=751fdaf8&lang=css"
script.render = render

export default script